export default {
  toasts: {
    success: 'Successfully redeemed gift card.',
    error: 'Failed to redeem gift card.',
  },
  title: 'Redeem Gift Card',
  subtitle: "Enter the gift card code and the amount to redeem from the customer's bill.",
  form: {
    amount: {
      label: 'Amount to Redeem',
    },
    code: {
      label: 'Gift Card Code',
    },
  },
  buttons: {
    redeem: 'Redeem',
    cancel: 'Cancel',
  },
};
